import { STARTS, TARGETS } from './data/titles';
import { hashString, mulberry32 } from './level/layout';

/** Daily #1 is 2026-09-29 (local calendar day, like most daily word games). */
const EPOCH = Date.UTC(2026, 8, 29);

export function dailyNumber(now = new Date()): number {
  const day = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.max(1, Math.floor((day - EPOCH) / 86_400_000) + 1);
}

export interface Pair {
  start: string;
  target: string;
}

export function dailyPair(n: number): Pair {
  const rng = mulberry32(hashString(`rabbit-hole-daily-${n}`));
  const start = STARTS[Math.floor(rng() * STARTS.length)];
  let target = TARGETS[Math.floor(rng() * TARGETS.length)];
  while (target === start) target = TARGETS[Math.floor(rng() * TARGETS.length)];
  return { start, target };
}

export function randomPair(): Pair {
  const start = STARTS[Math.floor(Math.random() * STARTS.length)];
  let target = TARGETS[Math.floor(Math.random() * TARGETS.length)];
  while (target === start) target = TARGETS[Math.floor(Math.random() * TARGETS.length)];
  return { start, target };
}

export function randomCurated(kind: 'start' | 'target'): string {
  const list = kind === 'start' ? STARTS : TARGETS;
  return list[Math.floor(Math.random() * list.length)];
}
